import { apiFetch } from '../utils/apiFetch';
const apiUrl = process.env.REACT_APP_API_URL;

export async function getEventsByProgramId(programId) {
  try {
    const response = await apiFetch(`${apiUrl}/events?program_id=${programId}`);
    if (!response.ok) throw new Error('Failed to fetch events');
    return await response.json();
  } catch (err) {
    console.error('[EventService] getEventsByProgramId error:', err);
    return [];
  }
}


export async function getEventById(eventId) {
  try {
    const response = await apiFetch(`${apiUrl}/events/${eventId}`);
    if (!response.ok) throw new Error('Failed to fetch event');
    return await response.json();
  } catch (err) {
    console.error('[EventService] getEventById error:', err);
    return null;
  }
}

// Optional: Create event
export async function createEvent(eventData) {
  try {
    const response = await apiFetch(`${apiUrl}/events`, {
      method: 'POST',
      body: JSON.stringify(eventData),
    });
    if (!response.ok) throw new Error('Failed to create event');
    return await response.json();
  } catch (err) {
    console.error('[EventService] createEvent error:', err);
    return null;
  }
}
